import { Kbd } from './kbd';
export default Kbd;
